module.exports = __webpack_public_path__ + "img/smartid.fcb951a9.svg";